import { useState } from 'react';

import Button from '~/common/componentMapper/Button/Button';
import Text from '~/common/componentMapper/Text/Text';
import Stack from '~/common/components/Stacks/Stack';

import { TITLE_ICON_TYPE } from '../../QuestionBox/constants';
import { HIDE_BOLT_ANSWER, SHOW_BOLT_ANSWER } from '../constants';
import DetailedAnswer from './DetailedAnswer';
import ExtractionDataIcon from './ExtractionDataIcon';

type BOLTAnswerFooterProps = {
  detailedAnswer?: string;
  confidenceLevel?: string | number;
  handleConfidenceLevelColor?: (...args: any[]) => any;
  answer?: string;
  showGaugeIcon?: boolean;
};

const BOLTAnswerFooter = ({
  answer = '',
  detailedAnswer = '',
  confidenceLevel = 0,
  handleConfidenceLevelColor = () => {},
  showGaugeIcon,
}: Readonly<BOLTAnswerFooterProps>) => {
  const iconColor = handleConfidenceLevelColor(confidenceLevel);
  const [showBOLTAnswer, setShowBOLTAnswer] = useState(false);
  const showIcon = showGaugeIcon && !Number.isNaN(confidenceLevel);

  return (
    <Stack
      sx={{
        paddingTop: showBOLTAnswer && '1rem',
        width: '100%',
      }}
    >
      {showBOLTAnswer && (
        <Stack direction="row" alignItems="center" width="100%">
          {showIcon && (
            <ExtractionDataIcon
              isConfidence={true}
              iconType={TITLE_ICON_TYPE.GAUGE}
              color={iconColor}
            />
          )}

          <Stack
            direction="column"
            width="100%"
            sx={{ fontStyle: 'italic', color: 'gray.600' }}
          >
            {!!answer && (
              <Text
                sx={{
                  width: '100%',
                  padding: 0,
                  textAlign: 'left',
                }}
                text={`BOLT Answer: ${answer}`}
              />
            )}
            {!!detailedAnswer && (
              <DetailedAnswer detailedAnswer={detailedAnswer} />
            )}
          </Stack>
        </Stack>
      )}

      <Stack
        direction="row"
        sx={{
          width: '100%',
          justifyContent: 'left',
          paddingTop: '1rem',
        }}
      >
        <Button
          type="linkButton"
          name="showBOLTAnswer"
          onClick={() => setShowBOLTAnswer((prev) => !prev)}
          data-tracking="show-footer-confidence-bolt-answer"
          label={showBOLTAnswer ? HIDE_BOLT_ANSWER : SHOW_BOLT_ANSWER}
        />
      </Stack>
    </Stack>
  );
};

export default BOLTAnswerFooter;
